const DEFAULT_LOCALE = process.env.VUE_APP_NUMBER_LOCALE || "nl-NL";

const getLocale = (locale) => locale || DEFAULT_LOCALE;

const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const formatNumber = (value, options = {}) => {
  const {
    locale,
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    fallback = "-",
  } = options;

  const numericValue = toNumber(value);
  if (numericValue === null) return fallback;

  return new Intl.NumberFormat(getLocale(locale), {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(numericValue);
};

export const formatCurrency = (value, options = {}) => {
  const {
    locale,
    currency = "EUR",
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    fallback = "-",
  } = options;

  const numericValue = toNumber(value);
  if (numericValue === null) return fallback;

  return new Intl.NumberFormat(getLocale(locale), {
    style: "currency",
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(numericValue);
};

export const getNumberLocale = () => DEFAULT_LOCALE;
